import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useI18n } from '../../i18n';

// Berechtigungen entsprechen den Routen in App.jsx
export const ADMIN_TILES = [
  { key: 'users', to: '/admin/users', icon: 'bi-people', anyOf: ['manage_users', 'manage_subordinates'] },
  { key: 'roles', to: '/admin/roles', icon: 'bi-shield-lock', anyOf: ['admin'] },
  { key: 'schedules', to: '/admin/schedules', icon: 'bi-calendar-week', anyOf: ['manage_schedules'] },
  { key: 'team', to: '/admin/team', icon: 'bi-person-lines-fill', anyOf: ['view_team_time'] },
  { key: 'teams', to: '/admin/teams', icon: 'bi-diagram-3', anyOf: ['manage_users', 'manage_subordinates'] },
  { key: 'company', to: '/admin/company', icon: 'bi-building-gear', anyOf: ['admin'] },
];

export default function AdminOverview() {
  const { hasPermission } = useAuth();
  const { t } = useI18n();
  const tiles = ADMIN_TILES.filter((tile) => tile.anyOf.some(hasPermission));

  return (
    <div>
      <h2 className="mb-1">{t('admin.overview.title')}</h2>
      <p className="text-muted mb-4">{t('admin.overview.subtitle')}</p>
      <div className="row g-3">
        {tiles.map((tile) => (
          <div className="col-12 col-md-6 col-xl-4" key={tile.key}>
            <Link to={tile.to} className="card h-100 text-decoration-none shadow-sm">
              <div className="card-body d-flex align-items-start">
                <i className={`bi ${tile.icon} fs-1 me-3 text-primary`} />
                <div>
                  <h5 className="card-title text-body">{t(`admin.overview.${tile.key}.title`)}</h5>
                  <p className="card-text text-muted mb-0">{t(`admin.overview.${tile.key}.desc`)}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
